import classNames from "classnames";
import {ForwardedRef, forwardRef} from "react";
import {SelectInstance} from "react-select";

import {Select} from "@/components/select/Select.tsx";
import {SelectEnumOption, SelectProps} from "@/components/select/Select.types.ts";
import {RUMAggregationType, RUMAggregationTypeLabels} from "@/pages/rum/v2/types.ts";

import styles from "./RUMAggregationSelect.module.scss";

export const RUMAggregationSelect = forwardRef(
  (
    {className, ...props}: SelectProps<SelectEnumOption<RUMAggregationType>>,
    ref: ForwardedRef<SelectInstance<SelectEnumOption<RUMAggregationType>, false>>
  ) => {
    const options = Object.keys(RUMAggregationType).map((key) => ({
      value: key as RUMAggregationType,
    }));
    const currentValue = options.find((o) => o.value === props.value?.value);
    return (
      <Select<SelectEnumOption<RUMAggregationType>>
        ref={ref}
        className={classNames(className, styles.aggregationSelect)}
        value={currentValue}
        options={options}
        getOptionValue={({value}) => value}
        getOptionLabel={({value}) => RUMAggregationTypeLabels[value]}
        {...props}
      />
    );
  }
);
